import React, { useState } from "react";
import MainLogo from "../../assets/images/maalogo.png";
import { Link } from "react-router-dom";
import { axiosInstance, config } from "../../pages/config";
import Loader from "./Loader";
import { notification } from "antd";
import { useInView } from 'react-intersection-observer';

const Footer = () => {
  const year = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onHandleSubmit = async (e) => {
    console.log("first");
    e.preventDefault();
    setLoading(false);
    try {
      const formData = new FormData();
      formData.append("email", email);
      const res = await axiosInstance.post("newsletter", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.success) {
        setEmail("");
        notification.open({
          message: "Message Received Successfully ",
          description:
            "Your message has been sent! 🎉 Thank you for reaching out to us. We’re excited to connect and will get back to you shortly. Stay tuned!",
          showProgress: true,
        });
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      {isLoading && <Loader />}
      <footer className="footer-area bg-efd7a9">
        <div className="container">
          <div className="row">
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView1 ? 'visible' : ''}`} ref={ref1}>
              <div className="single-footer-widget">
                <div className="logo">
                  <Link to={`${config.appUrl}`}>
                    <img alt="logo" loading="lazy" width="150" decoding="async" data-nimg="1" src={MainLogo} style={{ color: "transperent" }} />
                  </Link>
                </div>
                <p>At Maa vaishno jewellers, we create jewellery that reflects beauty, tradition, and trust. Our handcrafted designs are made to enhance every occasion and become a lasting symbol of your special moments.</p>
              </div>
            </div>
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView2 ? 'visible' : ''}`} ref={ref2}><div className="single-footer-widget ps-5">
              <h3>Quick Links</h3>
              <ul className="list">
                <li>
                  <Link to={`${config.appUrl}`}>Home</Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}about-us`}>About Us</Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}contact-us`}>
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}privacy-policy`}>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}terms-and-condition`}>
                    Terms and Condition
                  </Link>
                </li>
              </ul>
            </div>
            </div>
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView5 ? 'visible' : ''}`} ref={ref5}>
              <div className="single-footer-widget">
                <h3>Address</h3>
                <ul className="footer-contact-info">
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>Ward No 24, Lal Bazar, Bettiah, West Champaran, Bihar, 845438</li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                      </path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>Email : <a href="mailto:maavaishnoojewellers@gmail.com"> maavaishnoojewellers@gmail.com</a>
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                      </path>
                    </svg>Phone : <a href="tel:+91-7011967851">+91 70119 67851</a>
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    Monday to Sunday <br /> 10:00 AM to 8:00 PM
                  </li>
                </ul>
                <ul className="social-links">
                  <li>
                    <a href="https://www.facebook.com/share/1KzuMeNJ7h/" className="facebook" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                      </svg>
                    </a>
                  </li>
                  {/* <li>
                    <a href="https://x.com/CubexTechnology" className="twitter" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 50 50">
                        <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
                      </svg>

                    </a>
                  </li> */}
                  <li>
                    <a href="https://www.instagram.com/_maavaishno?igsh=MTcyNWYyNzY0dTRlZQ%3D%3D&utm_source=qr" className="instagram" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                      </svg>
                    </a>
                  </li>
                  {/* <li>
                      <a href="https://www.linkedin.com/" className="linkedin" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                          <rect x="2" y="9" width="4" height="12"></rect>
                          <circle cx="4" cy="4" r="2"></circle>
                        </svg>
                      </a>
                    </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="copyright-area">
                <p>Copywrite © {year}. All Rights Reserved
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="developed-area">
                <p>Design and Developed by &nbsp;
                  <Link to="https://smsmartinfotech.com/" target="_blank" className="footer-id">SMSmart Infotech</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
